import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Star, ArrowRight, Quote } from "lucide-react";
import Reveal from "../components/Reveal";
import {
  LINKS,
  IMAGES,
  ASTRO_PARAGRAPHS,
  ASTRO_YOGANANDA,
  ASTRO_CHART,
  ASTRO_TESTIMONIALS,
  CONTACT_TESTIMONIALS,
} from "../mock";

const ASTRO_ALL = [...ASTRO_TESTIMONIALS, CONTACT_TESTIMONIALS[0]];

export default function Astrology() {
  return (
    <div>
      {/* Header */}
      <section className="bg-gradient-to-b from-[#f3edf5] to-white pt-16 pb-10 md:pt-20 md:pb-14">
        <div className="max-w-4xl mx-auto px-5 text-center">
          <Reveal>
            <Star className="mx-auto text-purple mb-4" size={32} />
            <h1 className="font-serif-brand text-4xl md:text-5xl text-purple leading-tight">
              The positions of the sun, moon, and planets at the time of birth have a great
              influence on our lives
            </h1>
            <div className="brand-rule mx-auto mt-6" />
          </Reveal>
        </div>
      </section>

      {/* Intro paragraphs */}
      <section className="max-w-3xl mx-auto px-5 py-10 md:py-14">
        <div className="space-y-5 text-neutral-600 leading-relaxed">
          {ASTRO_PARAGRAPHS.map((p, i) => (
            <Reveal key={i} delay={i * 80}>
              <p>{p}</p>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Yogananda quote */}
      <section className="bg-[#f3edf5] py-14 md:py-20">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <Reveal>
            <Quote className="mx-auto text-purple mb-5" size={36} />
            <p className="font-serif-brand text-2xl md:text-3xl text-purple italic leading-relaxed">
              {ASTRO_YOGANANDA}
            </p>
            <p className="mt-6 tracking-[0.25em] uppercase text-sm text-neutral-500">
              Autobiography of a Yogi
            </p>
          </Reveal>
        </div>
      </section>

      {/* Birth chart */}
      <section className="max-w-6xl mx-auto px-5 py-16 md:py-24">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <Reveal>
            <img
              src={IMAGES.astro1}
              alt="Astrology birth chart"
              className="rounded-lg shadow-xl w-full object-cover"
            />
          </Reveal>
          <Reveal delay={120}>
            <div className="flex items-center gap-3 mb-3">
              <Sparkles className="text-[var(--teal-dark)]" size={22} />
              <h2 className="font-serif-brand text-3xl md:text-4xl text-purple">
                {ASTRO_CHART.title}
              </h2>
            </div>
            <div className="brand-rule mb-6" />
            <p className="text-neutral-600 leading-relaxed mb-4">{ASTRO_CHART.body}</p>
            <p className="text-neutral-500 leading-relaxed text-sm italic">{ASTRO_CHART.note}</p>
            <a
              href={LINKS.freeChart}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-brand btn-purple mt-8"
            >
              Get your free chart now <ArrowRight size={16} />
            </a>
          </Reveal>
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-[#f7fbfa] py-16 md:py-24">
        <div className="max-w-5xl mx-auto px-5">
          <Reveal className="text-center mb-14">
            <h2 className="font-serif-brand text-4xl md:text-5xl text-purple">Client Experiences</h2>
            <div className="brand-rule mx-auto mt-4" />
          </Reveal>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {ASTRO_ALL.map((t, i) => (
              <Reveal key={t.name} delay={i * 120}>
                <div className="h-full bg-white rounded-lg border border-neutral-100 shadow-sm hover:shadow-xl transition-shadow duration-300 p-8">
                  <Quote className="text-[var(--teal)] mb-4" size={30} />
                  <p className="text-neutral-600 italic leading-relaxed">{t.quote}</p>
                  <p className="mt-6 text-purple font-semibold tracking-wide-sm uppercase text-sm">
                    {t.name}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-3xl mx-auto px-5 py-16 md:py-20 text-center">
        <Reveal>
          <h2 className="font-serif-brand text-3xl md:text-4xl text-purple">
            Find out how you can benefit from astrology
          </h2>
          <div className="flex flex-wrap justify-center gap-3 mt-8">
            <Link to="/book" className="btn-brand btn-teal">
              Contact Kamla
            </Link>
            <Link to="/services" className="btn-brand btn-outline-teal">
              Services
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
